import type { Section } from '@common/formEngine/formEngine.types';
import { BezoekAanSpecialistOption } from '@common/enums';
import { dependsOn } from '@common/formEngine/dependsOn';
import { HolterDeviation, holterDeviationOptions } from './utils/deviationUtils';
import {
    HolterConclusionOption,
    holterConclusionOptions,
    type HolterConsultData,
} from './utils/gradingAndConsultUtils';
import { YesNoNoDeviations, yesNoNoDeviationsOptions } from './utils/utils';

export type HolterAdviceQuestionContentKeys = 'advice';

export const holterConsultSections: Section<HolterConsultData, HolterAdviceQuestionContentKeys>[] = [
    {
        fields: [
            {
                isRequired: true,
                key: 'conclusion',
                label: 'Conclusie',
                type: 'select',
                valueOptions: holterConclusionOptions,
            },
        ],
    },
    {
        fields: [
            {
                checkboxEnumType: HolterDeviation,
                include: dependsOn(
                    'conclusion',
                    ({ conclusion }) =>
                        conclusion === HolterConclusionOption.afwijkend ||
                        conclusion === HolterConclusionOption.alarmerend_afwijkend ||
                        conclusion === HolterConclusionOption.borderline
                ),
                isRequired: true,
                key: 'deviations',
                label: 'Afwijking in',
                type: 'nestedCheckboxGroup',
                valueOptions: holterDeviationOptions,
            },
            {
                key: 'additionalFindings',
                label: 'Toelichting bevindingen',
                type: 'textArea',
            },
            {
                isRequired: true,
                key: 'hasDiagnosis',
                label: 'Diagnose bekend',
                layout: 'row',
                type: 'radioGroup',
                valueOptions: yesNoNoDeviationsOptions,
            },
            {
                include: dependsOn('hasDiagnosis', ({ hasDiagnosis }) => hasDiagnosis === YesNoNoDeviations.yes),
                isRequired: true,
                key: 'workDiagnosis',
                label: 'Werkdiagnose',
                type: 'icd10',
            },
            {
                isRequired: true,
                key: 'visitSpecialist',
                label: 'Bezoek aan specialist nu nodig',
                layout: 'row',
                type: 'radioGroup',
                valueOptions: Object.values(BezoekAanSpecialistOption),
            },
        ],
        title: 'Diagnostische bevindingen',
    },
    {
        fields: [
            {
                key: 'advice',
                type: 'content',
            },
            {
                isRequired: dependsOn(
                    ['visitSpecialist'],
                    ({ visitSpecialist }) => visitSpecialist === BezoekAanSpecialistOption.zieBeleid
                ),

                key: 'policy',
                label: 'Beleid',
                type: 'textArea',
            },
            {
                key: 'additionalFollowUp',
                label: 'Toelichting vervolg',
                type: 'textArea',
            },
        ],
        title: 'Vervolg',
    },
];
